import React from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { withStyles } from '@material-ui/core/styles';

// Style overrides for the internals of Table.NoDataCell
const styles = {
    textContainer: {
        fontSize: '1.2rem'
    }
};

const NoDataCell = (props) => <Table.NoDataCell {...props}  />;

export default withStyles(styles)(NoDataCell);
